import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import NavbarFooterWrapper from "./NavbarFooterWrapper";
import { sortPostsByDateDesc, searchPosts } from "./blogData";

const BlogListPage = () => {
  const [query, setQuery] = useState("");
  const posts = useMemo(() => (query ? searchPosts(query) : sortPostsByDateDesc()), [query]);

  return (
    <NavbarFooterWrapper>
      <section className="blog">
        <div className="container">
          <div className="blog-header">
            <h1 className="blog-title">All Blogs</h1>
            <div className="blog-actions">
              <Link to="/blog" className="text-link">View latest</Link>
            </div>
          </div>

          <div className="blog-search">
            <input
              type="text"
              placeholder="Search blogs..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="search-input"
            />
          </div>

          <ul className="blog-list">
            {posts.map((p) => (
              <li key={p.slug} className="blog-list-item">
                <Link to={`/blog/${p.slug}`} className="blog-list-link">
                  <div className="blog-list-title">{p.title}</div>
                  <div className="blog-list-meta">{new Date(p.date).toLocaleDateString()}</div>
                </Link>
              </li>
            ))}
            {posts.length === 0 && <li className="blog-list-empty">No posts found.</li>}
          </ul>
        </div>
      </section>
    </NavbarFooterWrapper>
  );
};

export default BlogListPage;


